import React from 'react';
import ReactOwlCarousel, { OwlCarouselProps } from 'react-owl-carousel';

type Props = OwlCarouselProps & {
  xsItems?: number;
  smItems?: number;
  mdItems?: number;
  lgItems?: number;
  xlItems?: number;
  xxlItems?: number;
};

const GCarousel = ({
  items,
  xsItems,
  smItems,
  mdItems,
  lgItems,
  xlItems,
  xxlItems,
  dots = false,
  autoplay = true,
  loop = true,
  nav = true,
  ...others
}: Props) => {
  return (
    <ReactOwlCarousel
      navText={['<span class="bi bi-arrow-left-short"><span>', '<span class="bi bi-arrow-right-short"></span>']}
      items={items}
      nav={nav}
      dots={dots}
      autoplay={autoplay}
      loop={loop}
      responsive={{
        0: { items: xsItems ? xsItems : 1 },
        576: { items: smItems },
        768: { items: mdItems },
        1024: { items: lgItems },
        1200: { items: xlItems },
        1400: { items: xxlItems },
        1600: { items: items },
      }}
      {...others}
    ></ReactOwlCarousel>
  );
};

export default GCarousel;
